import ReactDOM from "react-dom";

import './pvz.scss'
import PickPoints from './../../../components/happy/order/templates/.default/react/steps/delivery/PickPoints.jsx'
import React, { useCallback, useEffect, useState } from "react";
const container = document.getElementById('manager-pvz-map')

if (container) {
    function PickPointsComponent() {
        const DELIVERIES = [{
            CODE : 'FIVE_POST', 
            NAME : '5 POST',
        }, {
            CODE : 'CDEK',
            NAME : 'СДЭК',
        }, {
            CODE : 'YANDEX_DELIVERY',
            NAME : 'Яндекс.Доставка',
        }]

        const [ deliveryCode, setDeliveryCode ] = useState(null)

        const onSelectPVZHandler = useCallback((point) => {
            let code = null

            if (deliveryCode === DELIVERIES[0].CODE) {
                code = point.POINT_GUID
                
            }

            console.log(point, point.POINT_GUID)

            prompt('Код точки самовывоза: ', point.POINT_GUID)
        }, [ deliveryCode ])

        return (<div className="manager-pvz">
            <div className="manager-pvz-tabs">
                { DELIVERIES.map((delivery) => (<button 
                    key={ delivery.CODE }
                    className={`button button_big ${ delivery.CODE === deliveryCode ? 'button_green' : 'button_flat' }`} 
                    onClick={() => setDeliveryCode(delivery.CODE)}
                >
                    { delivery.NAME }
                </button>)) }
            </div>

            <div className="manager-pvz-map">
                { deliveryCode && <PickPoints deliveryCode={ deliveryCode } isDivContainer={ true } onSelectPVZ={ onSelectPVZHandler } /> }
            </div>
        </div>)
    }

    setTimeout(() => {
        ReactDOM.render(<PickPointsComponent />, container)
    }, 0)
}